var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTacMoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.062,
    height: 55.062,
    viewBox: "0 0 55.062 55.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 55.062,
    height: 55.062,
    rx: 15,
    transform: "translate(0)",
    fill: "#e0057f",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 26.366,
    height: 30.979,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_342",
    "data-name": "Groupe 342",
    transform: "translate(-79.938 -2730)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_6",
    "data-name": "Groupe de masques 6",
    transform: "translate(79.938 2730)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 55.062,
    height: 55.062,
    transform: "translate(0 0)",
    fill: "#e0057f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_222",
    "data-name": "Groupe 222",
    transform: "translate(116.95 2747.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    d: "M4.261,1A3.261,3.261,0,1,0,7.522,4.261,3.264,3.264,0,0,0,4.261,1m0-1A4.261,4.261,0,1,1,0,4.261,4.261,4.261,0,0,1,4.261,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_6",
    "data-name": "Ligne 6",
    d: "M2.479.518h0L0,.5A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5l2.479.018a.5.5,0,0,1,0,1Z",
    transform: "translate(2.964 4.251)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_221",
    "data-name": "Groupe 221",
    transform: "translate(94.286 2747.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_219",
    "data-name": "Groupe 219",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_299",
    "data-name": "Trac\\xE9 299",
    d: "M155.54,114.665q-.279,0-.56-.018a8.365,8.365,0,0,1-7.293-11.254.589.589,0,0,1,.079-.309l.179-.309a8.381,8.381,0,0,1,.747-1.29l6.473-11.175.011-.027a2.789,2.789,0,0,0,.107-.279.589.589,0,0,1,1.106-.116l.168.357,6.752,12.861a.589.589,0,0,1,.067.288,8.366,8.366,0,0,1-7.838,11.272m-6.632-11.2a.588.588,0,0,1-.037.136,7.152,7.152,0,0,0-.483,3.489,7.242,7.242,0,0,0,6.668,6.382,7.188,7.188,0,0,0,7.139-9.871.588.588,0,0,1-.04-.163l-6.29-11.982L149.7,102.1c-.009.016-.019.031-.029.046a7.2,7.2,0,0,0-.666,1.149c-.008.017-.016.033-.025.049Z",
    transform: "translate(-137.532 -83.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_300",
    "data-name": "Trac\\xE9 300",
    d: "M7.5,23.482a.6.6,0,0,1-.109-.01c-3.76-.7-6.115-2.352-7-4.9C-.627,15.633.338,11.633,3.262,6.682A48.156,48.156,0,0,1,7.883.2.589.589,0,0,1,8.822.27L14.136,8.5a.589.589,0,0,1-.99.639L8.267,1.583C6.337,3.96-.375,12.771,1.508,18.185c.737,2.121,2.791,3.51,6.1,4.129A.589.589,0,0,1,7.5,23.482",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "TAC",
    d: "M2.862,10.165a.289.289,0,0,1-.054,0,.251.251,0,0,1-.1-.039.282.282,0,0,1-.041-.034q-.078-.078-.078-.19V3.713H.525q-.112,0-.19-.078t-.078-.19V2.618q0-.123.078-.2t.19-.078h5.7q.123,0,.2.078t.078.2v.827q0,.112-.078.19t-.2.078H4.171V9.9q0,.112-.078.19a.264.264,0,0,1-.042.034A.255.255,0,0,1,4,10.146a.279.279,0,0,1-.053.015.34.34,0,0,1-.059,0Zm3.478,0a.226.226,0,0,1-.044,0,.219.219,0,0,1-.042-.013.239.239,0,0,1-.039-.021.287.287,0,0,1-.037-.029q-.073-.067-.073-.168,0-.045.022-.1L8.822,2.618q.034-.112.129-.2t.263-.084h1.219q.168,0,.257.084t.134.2L13.519,9.83q.011.056.011.1,0,.1-.067.168a.254.254,0,0,1-.035.029.215.215,0,0,1-.038.021.2.2,0,0,1-.041.013.22.22,0,0,1-.043,0h-.973a.551.551,0,0,1-.073,0,.369.369,0,0,1-.063-.014.258.258,0,0,1-.052-.023.2.2,0,0,1-.042-.032q-.073-.073-.1-.14l-.526-1.364H8.163L7.637,9.953q-.022.067-.1.14a.2.2,0,0,1-.042.032.258.258,0,0,1-.052.023.369.369,0,0,1-.063.014.551.551,0,0,1-.073,0ZM8.554,7.3h2.538L9.817,3.848Zm8.878,2.974q-1.04,0-1.761-.363t-1.1-1.04q-.38-.676-.425-1.627-.011-.458-.011-.984t.011-1.006q.045-.939.43-1.621T15.682,2.59q.721-.363,1.75-.363.76,0,1.364.2t1.029.553q.425.352.66.822t.246,1.018q.011.1-.061.168t-.173.067H19.434q-.123,0-.2-.061t-.112-.207q-.179-.738-.615-1.006t-1.085-.268q-.749,0-1.2.419t-.481,1.381q-.034.917,0,1.879t.481,1.381q.447.419,1.2.419.649,0,1.085-.274t.615-1q.034-.157.112-.212t.2-.056H20.5q.1,0,.173.067t.061.168q-.011.548-.246,1.018t-.66.822q-.425.352-1.029.553T17.432,10.277Z",
    transform: "translate(96.796 2732)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacMoins);
export default __webpack_public_path__ + "static/media/TAC_MOINS.e363dd247c0b2410641994d2a6b70673.svg";
export { ForwardRef as ReactComponent };